var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    width: 512,
    height: 512,
    fill: "none",
    stroke: "#9DB09F",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 114,
    width: 80,
    height: 12,
    rx: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68 126 L76 172 H124 L132 126"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 114 V76"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100 100 C82 100 66 88 64 66 C84 66 98 78 100 100 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100 86 C102 62 118 46 142 46 C142 70 126 86 100 86 Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 174 H32 M42 174 H170"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.b767489f22f660a24c5f13a468f98661.svg";
export { ForwardRef as ReactComponent };